module.exports = __webpack_public_path__ + "static/media/firefox.4e5e285e.svg";